import React, { forwardRef } from 'react';
import { Tooltip } from '../tooltip';
import { IconButton } from '../icon-button';
import { Icon } from '../icon';
import { Label, Asterisk, TooltipContentWrapper } from './styled';
export const FormLabel = forwardRef(function FormLabel({ children, labelTooltip, required, ...props }, ref) {
    return (React.createElement(Label, { ref: ref, ...props },
        children,
        required && typeof children === 'string' ? (React.createElement(Asterisk, { "data-label-asterisk": true }, " *")) : null,
        labelTooltip ? (React.createElement(Tooltip, { content: labelTooltip, position: "top" },
            React.createElement(TooltipContentWrapper, null,
                React.createElement(IconButton, null,
                    React.createElement(Icon, { name: "info", size: "medium" }))))) : null));
});
